import { render, staticRenderFns } from "./add-common-dishe-form.vue?vue&type=template&id=c87b70ae&scoped=true&"
import script from "./add-common-dishe-form.vue?vue&type=script&lang=js&"
export * from "./add-common-dishe-form.vue?vue&type=script&lang=js&"
import style0 from "./add-common-dishe-form.vue?vue&type=style&index=0&id=c87b70ae&lang=less&scoped=true&"
import style1 from "./add-common-dishe-form.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b70ae",
  null
  
)

export default component.exports